import { postMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const CREATE_STAFF = 'CREATE_STAFF';
export const CREATE_STAFF_SUCCESS = 'CREATE_STAFF_SUCCESS';
export const CREATE_STAFF_FAILURE = 'CREATE_STAFF_FAILURE';

// Action Creators
export const createStaff = () => ({
  type: CREATE_STAFF,
});

export const createStaffSuccess = (data) => ({
  type: CREATE_STAFF_SUCCESS,
  payload: data,
});

export const createStaffFailure = (error) => ({
  type: CREATE_STAFF_FAILURE,
  payload: error,
});

// Thunk Function
export const createStaffCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(createStaff());
    try {
      const response = await postMethodWithToken(
        url.staff + data?.id + '/staff/',
        data?.detail
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(createStaffSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(createStaffFailure(response?.data));
      }
    } catch (error) {
      dispatch(createStaffFailure(error?.message));
    }
  };
};
